import { render, staticRenderFns } from "./ZConceptBadge.vue?vue&type=template&id=886e6b6a&scoped=true&"
import script from "./ZConceptBadge.vue?vue&type=script&lang=js&"
export * from "./ZConceptBadge.vue?vue&type=script&lang=js&"
import style0 from "./ZConceptBadge.vue?vue&type=style&index=0&id=886e6b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886e6b6a",
  null
  
)

export default component.exports